import { BaseService } from './baseService';

class OrdersService extends BaseService<Order, 'orderID', 'orders'> {
	constructor() {
		super('orderID', 'order', 'orders');
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new OrdersService();
